import dataTestids from '../constants/test-ids';
import LinkedInSVG from '../svg/LinkedIn';
import CircleButton from './CircleButton';

// TODO: This icon is incorrect; we need to use the same SVG as on prod
const LinkedInButton = () => {
  return (
    <a
      href='https://www.linkedin.com/company/movingworlds/mycompany/'
      data-testid={dataTestids.LAYOUT.FOOTER.LINKED_IN}
      target='_blank'
      rel='noreferrer'
    >
      <CircleButton>
        <div className='w-[18px] h-5'>
          <LinkedInSVG />
        </div>
      </CircleButton>
    </a>
  );
};

export default LinkedInButton;
